export const PROJECTS_DATA_LOAD = 'projects/DATA_LOAD'
